import axios from 'src/utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';
import { getUser } from './users';
import history from 'src/utils/history';
import store from 'src/store';

export const getRoles = (entityId, theSessionId) => {
  const sessionId = theSessionId ? theSessionId : getSessionId();
  return dispatch => {
    dispatch(getRolesRequest());
    axios({
      method: 'get',
      url: '/openempi-ws-rest/1.0/security/roles',
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId
      }
    })
      .then(res => {
        dispatch(getRolesSuccess(res.data));
      })
      .catch(err => {
        dispatch(getRolesFailure(err));
      });
  };
};

export const addRole = role => {
  const sessionId = getSessionId();
  delete role['roleId'];
  return dispatch => {
    axios({
      method: 'POST',
      url: '/openempi-ws-rest/1.0/security/roles',
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: role
    })
      .then(res => {
        dispatch(addRoleSuccess(res.data));
        history.push('/roles');
      })
      .catch(err => {
        dispatch(saveRoleFailure(err));
      });
  };
};

export const updateRole = (id, role) => {
  const sessionId = getSessionId();
  delete role['roleId'];
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/security/roles/' + id,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      data: role
    })
      .then(res => {
        dispatch(saveRoleSuccess(res.data));
        const currUser = store.getState().session.user;
        dispatch(getUser(currUser.id));
        history.push('/roles');
      })
      .catch(err => {
        dispatch(saveRoleFailure(err));
      });
  };
};

export const deleteRole = roleId => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/security/roles/' + roleId,
      headers: {
        Accept: 'application/json',
        'Content-type': 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      }
    })
      .then(res => {
        dispatch(deleteRoleSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteRoleFailure(err));
      });
  };
};

const addRoleSuccess = data => {
  return {
    type: Constants.ROLES_ADD_SUCCESS,
    payload: data
  };
};

const saveRoleSuccess = data => {
  return {
    type: Constants.ROLES_SAVE_SUCCESS,
    payload: data
  };
};

const saveRoleFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ROLES_SAVE_FAILURE,
    payload
  };
};

const deleteRoleSuccess = data => {
  return {
    type: Constants.ROLES_DELETE_SUCCESS,
    payload: data
  };
};

const deleteRoleFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ROLES_DELETE_FAILURE,
    payload
  };
};

export const clearRolesError = () => {
  return {
    type: Constants.ROLES_CLEAR_ERROR
  };
};

const getRolesRequest = () => {
  return {
    type: Constants.ROLES_GET_REQUEST
  };
};

const getRolesSuccess = data => {
  return {
    type: Constants.ROLES_GET_SUCCESS,
    payload: data
  };
};

const getRolesFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.ROLES_GET_FAILURE,
    payload
  };
};
